import { ReactElement } from 'react';
import { IComponentSpacerFields } from 'types/contentful';

export default function Spacer({ size }: IComponentSpacerFields): ReactElement {
  return <div style={{ height: `${size}px` }} />;
}
